// Libs
import React from 'react'

// CSS
import "./styles.scss"

const SearchLoading = () => {
  return (
    <div className="search-loading">
      <div className="search-loading__dot"></div>
      <div className="search-loading__dot"></div>
      <div className="search-loading__dot"></div>
    </div>
  )
}

export default SearchLoading
